export default __webpack_public_path__ + "static/29112-83ffcaf5ac661334e55be7f2b7252937.jpg";